import React from "react";
import { Table } from "@public/ui-toolkit";
import { Button } from "antd";
import moment from "moment";
import { useHistory } from "react-router";
import jwtDecode from "jwt-decode";
import { VideoCameraOutlined, EyeOutlined } from '@ant-design/icons';

const typeEnum = [
  {
    name: "Virtual",
    key: 0,
  },
  {
    name: "In Person",
    key: 1,
  },
];

const chimeMeetingStatus = [
  { name: "Pending", key: 0 },
  { name: "Failed", key: 1 },
  { name: "Success", key: 2 },
];

const MyMeetings = ({ meetings, portal }) => {
  const history = useHistory();
  const getUserDetails = () => {
    var token = sessionStorage.getItem("token") ?? localStorage.getItem("token");
    if (token !== null) {
      return jwtDecode(token);
    }
  };
  const allocatorColumns = [
    { name: "Topic", key: "topic" },
    { name: "HedgeFund", key: "hedgefund", childKey: "name" },
    {
      name: "Date",
      key: "startTime",
      type: "date",
      format: (date) => moment(date).format("DD MMM YYYY"),
    },
    {
      name: "Start Time",
      key: "startTime",
      type: "date",
      renderContent: (meet) => {
        var utcDate = new Date(meet?.startTime);
        var timezoneOffset = -utcDate.getTimezoneOffset();
        var localDate = new Date(utcDate.getTime() - (timezoneOffset * 60000));
        return (moment(localDate).format("hh:mm A"));
      }
    },
    {
      name: "Type",
      key: "type",
      renderContent: (t) => {
        return (
          <span className="badge badge-pill badge-secondary">
            {typeEnum[t?.type]?.name}
          </span>
        );
      },
    },
    {
      name: "Chime Status",
      key: "chimeMeetingStatus",
      renderContent: (t) => {
        return chimeMeetingStatus[t?.chimeMeetingStatus]?.name ?? "N/A";
      },
    },
    {
      name: "Meeting Status",
      key: "Status",
      renderContent: (t) => {
        return (
          <span>
            <i className="fa fa-circle mr-1"></i>
            {t.status}
          </span>
        );
      },
    },
    {
      name: "Action",
      key: "action",
      component: (row) => (
        <>
          <Button
            style={{ border: "0px", color: "#3ac1b5" }}
            icon={<EyeOutlined className="icon-action" />}
            onClick={() => history.push(`/meeting?appointmentId=${row.id}`)}
          />
          {(row.appointmentStatus === 0 ||
            row.appointmentStatus === 1 ||
            row.appointmentStatus === 2) &&
            row.type === 0 && (
              <Button
                style={{ border: "0px", color: "#3ac1b5" }}
                icon={<VideoCameraOutlined className="icon-action" />}
                onClick={() => {
                  history.push(`${row.url}&name=${getUserDetails()?.FullName}`);
                }}
                disabled={row.chimeMeetingStatus !== 2 ? true : false}
              />
            )}
        </>
      ),
    },
  ];

  const hedgefundColumns = [
    { name: "Topic", key: "topic" },
    { name: "Allocator", key: "allocator", childKey: "name" },
    {
      name: "Date",
      key: "startTime",
      type: "date",
      format: (date) => moment(date).format("DD MMM YYYY"),
    },
    {
      name: "Start Time",
      key: "startTime",
      type: "date",
      renderContent: (meet) => {
        var utcDate = new Date(meet?.startTime);
        var timezoneOffset = -utcDate.getTimezoneOffset();
        var localDate = new Date(utcDate.getTime() - (timezoneOffset * 60000));
        return (moment(localDate).format("hh:mm A"));
      }
    },
    {
      name: "Type",
      key: "type",
      renderContent: (t) => (
        <span className="badge badge-pill badge-secondary">
          {typeEnum[t?.type]?.name}
        </span>
      ),
    },
    {
      name: "Meeting Status",
      key: "Status",
      renderContent: (t) => {
        return (
          <span>
            <i className="fa fa-circle mr-1"></i>
            {t.status}
          </span>
        );
      },
    },
    {
      name: "Chime Status",
      key: "chimeMeetingStatus",
      renderContent: (t) => {
        return chimeMeetingStatus[t?.chimeMeetingStatus]?.name ?? "N/A";
      },
    },
    {
      name: "Action",
      key: "action",
      component: (row) => (
        <>
          <Button
            style={{ border: "0px", color: "#3ac1b5" }}
            icon={<EyeOutlined className="icon-action" />}
            onClick={() => history.push(`/meeting?appointmentId=${row.id}`)}
          />
          {(row.appointmentStatus === 0 ||
            row.appointmentStatus === 1 ||
            row.appointmentStatus === 2) &&
            row.type === 0 && (
              <Button
                style={{ border: "0px", color: "#3ac1b5" }}
                type="primary"
                className="icon-action"
                icon={<VideoCameraOutlined />}
                onClick={() => {
                  history.push(`${row.url}&name=${getUserDetails()?.FullName}`);
                }}
                disabled={row.chimeMeetingStatus !== 2 ? true : false}
              ></Button>
            )}
        </>
      ),
    },
  ];
  return (
    <Table
      columns={portal === "hedgefund" ? hedgefundColumns : allocatorColumns}
      //onRowClick={(row) => history.push(`/meeting?appointmentId=${row.id}`)}
      data={meetings}
    />
  );
};

export default MyMeetings;
